export default {
  conversationsFilters: 'Conversations Filters',
  orderFilter: 'Order Filter',
  recentConversations: 'Recent Conversations',
  oldConversations: 'Older conversations',
  olderConversations: 'Older Conversations',
  filterType: 'Type',
  allConversations: 'All Conversations',
  selfConversations: 'Your Conversations',
  withBotConversations: 'Bot Conversations',
  waitingForAdvisor: 'Waiting for Advisor',
  closedConversations: 'Closed',
  channelFilter: 'Channel',
  facebookMessenger: 'Facebook Messenger',
  instagram: 'Instagram',
  web: 'Web',
  whatsapp: 'Whatsapp',
  wizard: 'Wizard',
  adviserFilter: 'Adviser',
  searchAdviser: 'Search Adviser',
  myChats: 'My chats',
  withBot: 'With bot',
  closed: 'Closed',
  allChannels: 'All channels',
  unansweredConversations: 'Unanswered'
}
